import { isBefore } from 'date-fns';
import { useHabits } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { TaskType } from 'shared/types/task-base';
import { initialWeekStartsOn } from 'shared/types/week-days';
import { getActiveSchedule } from 'shared/utils/get-active-schedule';
import { getTaskDueDate } from 'shared/utils/get-task-due';

export const useOverdueHabits = (weekStartsOn = initialWeekStartsOn) => {
  const today = useToday();
  const habits = useHabits({
    uncompletedOnly: true,
    unArchivedOnly: true,
    unFrozenOnly: true,
  });

  return useMemo(
    () =>
      habits.filter((habit) => {
        if (habit.type === TaskType.Habit && habit.hideOnTodo) {
          return false;
        }

        const activeSchedule = getActiveSchedule(habit.schedules);
        if (!activeSchedule) {
          return false;
        }

        const dueDate = getTaskDueDate(habit, { today, weekStartsOn });

        return dueDate ? isBefore(dueDate, today) : false;
      }),
    [habits, today, weekStartsOn],
  );
};
